import { EdgeLoadConnectUnreadTotalRepository } from '@/shared/infra/repositories'
import { makeSupabaseEdgeHttpClient } from '@/main/factories/http'
import type { LoadConnectUnreadTotal } from '@/shared/domain/use-cases'

export function makeLoadConnectUnreadTotal(): LoadConnectUnreadTotal {
  return new EdgeLoadConnectUnreadTotalRepository(makeSupabaseEdgeHttpClient()).execute
}
